import { motion } from "framer-motion";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const StepIndicator = ({ currentStep, totalSteps }: StepIndicatorProps) => (
  <div className="flex items-center gap-2">
    {Array.from({ length: totalSteps }, (_, i) => (
      <motion.div
        key={i}
        className="h-1 rounded-full"
        initial={false}
        animate={{
          width: i + 1 === currentStep ? 24 : 8,
          backgroundColor:
            i + 1 <= currentStep
              ? "hsl(var(--primary))"
              : "hsl(var(--muted-foreground) / 0.2)",
        }}
        transition={{ duration: 0.3 }}
      />
    ))}
  </div>
);

export default StepIndicator;
